module.exports = __webpack_public_path__ + "img/sovos.02bb980c.png";